export default [
  {
    name: 'Good',
    value: 0,
    class: 'default',
  },
  {
    name: 'Moderate',
    value: 1,
    class: 'info',
  },
  {
    name: 'Bad',
    value: 2,
    class: 'danger',
  },
];
